import { Component, OnInit } from '@angular/core';
import { InfoButton } from '../../../../models/client-configuration';
import { HeaderService } from '../../services/header.service';
import { ConfigService } from '../../../../services/config.service';

@Component({
  selector: 'app-header-help-button',
  templateUrl: './header-help-button.component.html',
  styleUrls: ['./header-help-button.component.scss']
})
export class HeaderHelpButtonComponent implements OnInit {
  helpUrl: string | null = null;
  infoButtons: InfoButton[] = [];

  constructor(
    private readonly configService: ConfigService,
    private readonly headerService: HeaderService,
  ) { }

  ngOnInit(): void {
    this.helpUrl = this.configService.get().helpUrl;
    this.infoButtons = this.configService.get().infoButtons;
  }

  handleHelp() {
    this.headerService.openHelp();
  }

  handleInfoButton(button: InfoButton) {
    this.headerService.openInfo(button);
  }
}
